import baseRequest from "../_core/baseRequest";

const buildPoolShiftForecastQuery = params => {
    const searchParams = new URLSearchParams();

    if (params?.startDate) {
        searchParams.set("startDate", params.startDate);
    }

    if (params?.endDate) {
        searchParams.set("endDate", params.endDate);
    }

    if (params?.skip != null) {
        searchParams.set("skip", String(params.skip));
    }

    if (params?.limit != null) {
        searchParams.set("limit", String(params.limit));
    }

    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : "";
};

export default {
    /* havuz bölgesinin günlük vardiya forecastlerini getirir */
    getDailyForecast: params => baseRequest.post(`poolshifts/getDailyForecast`, params),

    /* havuz bölgesine belirtilen tarih için forecast oluşturur */
    setDailyForecast: params => baseRequest.post(`poolshifts/setDailyForecast`, params),

    /* havuz bölgesine belirtilen tarih için forecast bilgilerini getirir */
    getPoolShiftForecastByDate: params =>
        baseRequest.get(
            `poolshifts/poolShiftForecastByDate?date=${params.date}&poolId=${params.poolId}`
        ),

    /* havuz bölgesinden seçilen forecasti siler */
    removeDailyForecast: props => baseRequest.post(`poolshifts/removeDailyForecast`, props),

    /* havuz bölgesinde seçilen forecast için hesaplama yaptırır */
    calculatePoolShiftSlotForecast: params =>
        baseRequest.post(`poolshifts/calculatePoolShiftSlotForecast`, params),

    /* havuz bölgesinde seçilen forecastin gösterimini sağlar */
    showDailyForecast: params => baseRequest.post(`poolshifts/showDailyForecast`, params),

    /*seçilen havuz bölgelerine ait forecast bilgilerini kopyalar*/
    copyForecast: params => baseRequest.post(`poolshifts/copyForecastToSpecificDate`, params),

    /* havuz bölgesi vardiya sistemi için genel saat slotlarını listeler (yarım saatlik slotlar...) */
    getShiftHours: () => baseRequest.get(`poolshifts/getShiftHours`),

    /* havuz bölgesinin slot tablosuna ait hücreleri listeler */
    getDailyShiftTable: () => baseRequest.get(`poolshifts/getDailyShiftTable`),

    /* havuz bölgesine ait seçilen tarih aralığındaki hücrelerdeki verileri listeler */
    getDailySlotsByPoolId: props => baseRequest.post(`poolshifts/getDailySlotsByPoolId`, props),

    /* havuz bölgesine ait tüm vardiya bilgilerini listeler */
    getAllPoolShifts: props =>
        baseRequest.get(
            `poolshifts/getAll?${props?.page ? `page=${props.page}` : ""}${
                props?.limit ? `&limit=${props.limit}` : ""
            }`
        ),

    /* havuz bölgesine seçilen vardiya slotunu günceller */
    setDailySlotById: props => baseRequest.post(`poolshifts/setDailySlotById`, props),

    /* havuz bölgesine ait vardiya bilgilerini listeler */
    getCourierShiftTable: props => baseRequest.post(`poolshifts/getCourierShiftTable`, props),

    /* havuz bölgesine ait kuryeleri listeler */
    getPoolCouriers: props => baseRequest.post(`poolshifts/getPoolCouriers`, props),

    /* havuz bölgesine ait vardiya iptal taleplerini listeler */
    getCancelRequests: props => baseRequest.post(`poolshifts/getCancelRequests`, props),

    /* havuz bölgesine ait vardiya iptal talebini onaylar */
    approveCancelRequest: props => baseRequest.post(`poolshifts/approveCancelRequest`, props),

    /* havuz bölgesine ait vardiya slotuna kurye ataması yapar */
    bookSlotByDateAndHour: props => baseRequest.post(`poolshifts/bookSlotByDateAndHour`, props),

    /* havuz bölgesine ait vardiya slotundaki kurye atamasını iptal eder */
    cancelSlotByDateAndHour: props => baseRequest.post(`poolshifts/cancelSlotByDateAndHour`, props),

    /* havuz bölgesine ait kurye vardiyalarını listeler */
    getCourierPoolShifts: props => {
        const queryParams = new URLSearchParams();
        if (props?.city && props?.city !== "all") queryParams.append("city", props.city);
        if (props?.poolId && props?.poolId !== "all") queryParams.append("poolId", props.poolId);
        /* Sabit entegrede havuz filtresi olmadığı için daraltma firma/şube ile yapılıyor. */
        if (props?.companyId && props?.companyId !== "all")
            queryParams.append("companyId", props.companyId);
        if (props?.subCompanyId) queryParams.append("subCompanyId", props.subCompanyId);
        if (props?.date) queryParams.append("date", props.date);
        if (props?.searchText) queryParams.append("searchText", props.searchText);
        /* Zorunlu: havuz mu sabit entegre mi listeleneceğini belirler ("pool" | "dedicatedIntegration") */
        if (props?.integrationType) queryParams.append("integrationType", props.integrationType);

        const queryString = queryParams.toString();
        return baseRequest.get(`poolshifts/poolShift${queryString ? `?${queryString}` : ""}`);
    },

    /* havuz / sabit entegre vardiya listesini Excel olarak indirir; hangi listenin
       aktarılacağını poolShift listesindeki gibi integrationType belirler ("pool" |
       "dedicatedIntegration"). Yanıt base64 döner. */
    downloadPoolShiftExcelFile: props => {
        const queryParams = new URLSearchParams();
        if (props?.date) queryParams.append("date", props.date);
        if (props?.integrationType) queryParams.append("integrationType", props.integrationType);
        if (props?.status && props.status !== "all") queryParams.append("status", props.status);

        const queryString = queryParams.toString();
        return baseRequest.get(
            `poolshifts/poolShift/export${queryString ? `?${queryString}` : ""}`
        );
    },

    /* havuz bölgesine ait vardiya saatini değiştirir */
    changeCourierPoolShiftHour: params =>
        baseRequest.put(`poolshifts/changeCourierPoolShiftHour`, params),

    /* havuz bölgesine ait vardiya kuryesini değiştirir */
    changeCourierPoolShift: params => baseRequest.put(`poolshifts/changeCourierPoolShift`, params),

    /* havuz bölgesine ait kuryenin vardiyalarını iptal eder*/
    cancelCourierPoolShift: params => baseRequest.put(`poolshifts/cancelCourierPoolShift`, params),

    /* vardiya değişim geçmişini listeler */
    getPoolShiftSyChangeLogs: params =>
        baseRequest.post(`poolshifts/poolShiftSyChangeLogs`, params),

    /* havuz bölgelerine ait yoğunluk bilgilerini listeler*/
    getPoolsAvailableRates: props => baseRequest.post(`poolshifts/getPoolsAvailableRates`, props),

    /* seçilen kuryeye seçilen tarih aralığında joker tanımlaması yapar*/
    setJokerCourierForShift: props => baseRequest.post(`poolshifts/setJokerCourierForShift`, props),

    /* havuz bölgesine ait vardiya bilgilerini excel dosyasından yükler */
    bookSlotsWithExcel: params => baseRequest.post(`poolshifts/bookSlotsWithExcel`, params, true),

    /* seçilen havuzda, seçilen bilgi kategorisindeki kuryeleri listeler */
    getPoolCouriersByState: props =>
        baseRequest.post(`poolshifts/getCourierCountsForPoolByState`, props),

    /* seçilen kuryeye seçilen tarih aralığında havuz vardiya tanımlaması yapar*/
    bookMultipleSlots: props => baseRequest.post(`poolshifts/bookMultipleSlots`, props),

    /* seçilen gün ve saate, belirtilen limitte havuz slotu oluşturur */
    createPoolShiftDailySlot: props =>
        baseRequest.post(`poolshifts/createPoolShiftDailySlot`, props),

    /* dedike entegrasyon vardiya sayılarını getirir */
    getPoolShiftCountsByForecastDate: params => {
        const queryString = buildPoolShiftForecastQuery(params);
        return baseRequest.get(
            `poolshifts/getPoolShiftCountsByForecastDate/${params.subcompanyId}${queryString}`
        );
    },

    /* dedike entegrasyon aktif vardiyaları getirir */
    getActivePoolShiftByForecastDate: params => {
        const queryString = buildPoolShiftForecastQuery(params);
        return baseRequest.get(
            `poolshifts/getActivePoolShiftByForecastDate/${params.subcompanyId}${queryString}`
        );
    },

    /* dedike entegrasyon planlanan vardiyaları getirir */
    getPlannedPoolShiftByForecastDate: params => {
        const queryString = buildPoolShiftForecastQuery(params);
        return baseRequest.get(
            `poolshifts/getPlannedPoolShiftByForecastDate/${params.subcompanyId}${queryString}`
        );
    },

    /* dedike entegrasyon tamamlanan vardiyaları getirir */
    getCompletedPoolShiftByForecastDate: params => {
        const queryString = buildPoolShiftForecastQuery(params);
        return baseRequest.get(
            `poolshifts/getCompletedPoolShiftByForecastDate/${params.subcompanyId}${queryString}`
        );
    }
};
